import { render, staticRenderFns } from "./CategoryNavi.vue?vue&type=template&id=23fb44c8&scoped=true&"
import script from "./CategoryNavi.vue?vue&type=script&lang=ts&"
export * from "./CategoryNavi.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryNavi.vue?vue&type=style&index=0&id=23fb44c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fb44c8",
  null
  
)

export default component.exports